export default __webpack_public_path__ + "static/media/reflection-icon.e872b7d5.svg";